import { css } from "@emotion/react";

export const invisibleButton = css`
  appearance: none;
  outline: none;
  border: none;
  background: none;
  margin: 0;
  padding: 0;

  &:active,
  &:hover,
  &:focus {
    outline: none;
    border: none;
    background: none;
    margin: 0;
    padding: 0;
  }
`;

export const fullWidthInput = css`
  input {
    width: 100%;
  }
`;

export const notDraggableStyles = css`
  user-select: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export const textEllipsisStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const textEllipsisStylesWithWrap = css`
  overflow: hidden;
  text-overflow: ellipsis;
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const textMultilineEllipsisStyles = (lines: number) => css`
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
`;
